import { ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS } from 'constants/types/analyticsTypes';
import { convertSnakeCaseKeysToCamelCase } from 'utils';
export interface IContentEngagementData {
  concepts: Concept[];
  entities: Entity[];
  keywords: Keyword[];
  content: Content[];
  accountName: string;
  totalArticlesCount: number;
}

export interface Concept {
  text: string;
  relevance: number;
}

export interface Content {
  articleId: number;
  articleTitle: string;
  articleImage: string;
  articleLink: string;
  emailName: string;
  emailSentDate: string;
  totalClicks: number;
  lastClickDate: string;
  score: number;
}

export interface Entity {
  entity: string;
  relevance: number;
}

export interface Keyword {
  keyword: string;
  relation: number;
}

interface IContentEngagementListing {
  loading: boolean;
  loaded: boolean;
  data: IContentEngagementData;
  campaignIds: string[];
  emailIds: string[];
  redirectUrl: string;
  exportButtonDisable: boolean;
  // isChartDataLoaded: boolean;
  isSearch: boolean;
}

const initialState = {
  loading: false,
  loaded: false,
  data: {
    totalArticlesCount: 0,
    accountName: '',
    concepts: [],
    entities: [],
    keywords: [],
    content: [],
  } as IContentEngagementData,
  campaignIds: [],
  emailIds: [],
  redirectUrl: '',
  exportButtonDisable: false,
  isSearch: false,
};

export const accountsContentEngagementReducer = (state: IContentEngagementListing = initialState, action: any) => {
  const newState = { ...state };
  let newData = undefined;

  //  array of types related to this reducer
  let DEFAULT_VALUES_IN_REDUCER = Object.values(ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS).map((item) => item);

  // check if the dispatched action type is in the array and action.payload
  if (action?.payload && DEFAULT_VALUES_IN_REDUCER.includes(action.type)) {
    newData = convertSnakeCaseKeysToCamelCase(action?.payload);
  }
  switch (action.type) {
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD:
      newState.loading = true;
      newState.loaded = false;
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_SUCCESS:
      newState.loading = false;
      newState.loaded = true;
      if (action.payload.offset > 0) {
        newState.data.content = [...newState.data.content, ...newData.data.content];
        newState.data.totalArticlesCount = newData.data.totalArticlesCount;
        newState.data.accountName = newData.data.accountName;
      } else {
        newState.data = newData.data;
      }
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_MORE:
      newState.loading = true;
      newState.loaded = false;
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_MORE_SUCCESS:
      newState.loading = false;
      newState.loaded = true;
      newState.data.content = [...newState.data.content, ...newData.data.content];
      newState.data.totalArticlesCount = newData.data.totalArticlesCount;
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.LOAD_FAIL:
      newState.loading = false;
      newState.loaded = false;
      newState.data.content = [];
      newState.data.accountName = '';
      newState.data.concepts = [];
      newState.data.entities = [];
      newState.data.keywords = [];
      newState.data.totalArticlesCount = 0;
      return newState;
    // case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.RESET:
    //   newState.loading = false;
    //   newState.loaded = false;
    //   newState.data = { ...initialState.data } as IContentEngagementData;
    //   return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_SELECTED_CAMPAIGNS:
      newState.campaignIds = action.payload.campaignIds;
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_SELECTED_EMAILS:
      newState.emailIds = action.payload.emailIds;
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.IS_SEARCH:
      newState.isSearch = action.payload;
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.RESET:
      newState.data = {
        totalArticlesCount: 0,
        accountName: '',
        concepts: [],
        entities: [],
        keywords: [],
        content: [],
      };
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_REDIRECT_URL:
      newState.redirectUrl = action.payload.redirectUrl;
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.RESET_REDIRECT_URL:
      newState.redirectUrl = '';
      return newState;
    case ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_EXPORT_BUTTON:
      newState.exportButtonDisable = action.payload;
      return newState;
    default:
      return newState;
  }
};
